/* *************************************************************************************************
App
************************************************************************************************* */
export const SET_FORM_TYPE = 'SET_FORM_TYPE';
export const SET_RATING_TYPE = 'SET_RATING_TYPE';

/* *************************************************************************************************
Drivers
************************************************************************************************* */
export const FETCH_DRIVERS = 'FETCH_DRIVERS';
export const FETCH_DRIVERS_LOADING = 'FETCH_DRIVERS_LOADING';
export const FETCH_DRIVERS_ERROR = 'FETCH_DRIVERS_ERROR';
export const FETCH_DRIVERS_SUCCESS = 'FETCH_DRIVERS_SUCCESS';

/* *************************************************************************************************
Form
************************************************************************************************* */
export const CLEAR_FORM = 'CLEAR_FORM';
export const UPDATE_FIELD = 'UPDATE_FIELD';

export const ADD_TO_GROUP = 'ADD_TO_GROUP';
export const EDIT_IN_GROUP = 'EDIT_IN_GROUP';
export const REMOVE_FROM_GROUP = 'REMOVE_FROM_GROUP';

/* *************************************************************************************************
Profile
************************************************************************************************* */
export const UPLOAD_PROFILE_IMAGE = 'UPLOAD_PROFILE_IMAGE';
export const UPLOAD_PROFILE_IMAGE_LOADING = 'UPLOAD_PROFILE_IMAGE_LOADING';
export const UPLOAD_PROFILE_IMAGE_ERROR = 'UPLOAD_PROFILE_IMAGE_ERROR';
export const UPLOAD_PROFILE_IMAGE_SUCCESS = 'UPLOAD_PROFILE_IMAGE_SUCCESS';

export const DELETE_PROFILE_IMAGE = 'DELETE_PROFILE_IMAGE';
export const DELETE_PROFILE_IMAGE_LOADING = 'DELETE_PROFILE_IMAGE_LOADING';
export const DELETE_PROFILE_IMAGE_ERROR = 'DELETE_PROFILE_IMAGE_ERROR';
export const DELETE_PROFILE_IMAGE_SUCCESS = 'DELETE_PROFILE_IMAGE_SUCCESS';

export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
export const UPLOAD_DOCUMENT_LOADING = 'UPLOAD_DOCUMENT_LOADING';
export const UPLOAD_DOCUMENT_ERROR = 'UPLOAD_DOCUMENT_ERROR';
export const UPLOAD_DOCUMENT_SUCCESS = 'UPLOAD_DOCUMENT_SUCCESS';

export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const DELETE_DOCUMENT_LOADING = 'DELETE_DOCUMENT_LOADING';
export const DELETE_DOCUMENT_ERROR = 'DELETE_DOCUMENT_ERROR';
export const DELETE_DOCUMENT_SUCCESS = 'DELETE_DOCUMENT_SUCCESS';

export const CREATE_PROFILE = 'CREATE_PROFILE';
export const CREATE_PROFILE_LOADING = 'CREATE_PROFILE_LOADING';
export const CREATE_PROFILE_ERROR = 'CREATE_PROFILE_ERROR';
export const CREATE_PROFILE_SUCCESS = 'CREATE_PROFILE_SUCCESS';

export const FETCH_PROFILE_OPTIONS = 'FETCH_PROFILE_OPTIONS';
export const FETCH_PROFILE_OPTIONS_LOADING = 'FETCH_PROFILE_OPTIONS_LOADING';
export const FETCH_PROFILE_OPTIONS_ERROR = 'FETCH_PROFILE_OPTIONS_ERROR';
export const FETCH_PROFILE_OPTIONS_SUCCESS = 'FETCH_PROFILE_OPTIONS_SUCCESS';

/* *************************************************************************************************
Rating Driver
************************************************************************************************* */
export const RATING_UPDATE_FIELD = 'RATING_UPDATE_FIELD';
export const RATING_REMOVE_FIELD = 'RATING_REMOVE_FIELD';
export const RATING_REMOVE_NON_HEADER_FIELDS = 'RATING_REMOVE_NON_HEADER_FIELDS';

export const CREATE_DRIVER_RATING = 'CREATE_DRIVER_RATING';
export const CREATE_DRIVER_RATING_LOADING = 'CREATE_DRIVER_RATING_LOADING';
export const CREATE_DRIVER_RATING_ERROR = 'CREATE_DRIVER_RATING_ERROR';
export const CREATE_DRIVER_RATING_SUCCESS = 'CREATE_DRIVER_RATING_SUCCESS';

export const FETCH_DRIVER_RATING_OPTIONS = 'FETCH_DRIVER_RATING_OPTIONS';
export const FETCH_DRIVER_RATING_OPTIONS_LOADING = 'FETCH_DRIVER_RATING_OPTIONS_LOADING';
export const FETCH_DRIVER_RATING_OPTIONS_ERROR = 'FETCH_DRIVER_RATING_OPTIONS_ERROR';
export const FETCH_DRIVER_RATING_OPTIONS_SUCCESS = 'FETCH_DRIVER_RATING_OPTIONS_SUCCESS';

/* *************************************************************************************************
Rating Self
************************************************************************************************* */
export const RATING_SELF_UPDATE_FIELD = 'RATING_SELF_UPDATE_FIELD';
export const RATING_SELF_REMOVE_FIELD = 'RATING_SELF_REMOVE_FIELD';
export const RATING_SELF_REMOVE_NON_HEADER_FIELDS = 'RATING_SELF_REMOVE_NON_HEADER_FIELDS';
export const RATING_SELF_REMOVE_ENGINE_FIELDS = 'RATING_SELF_REMOVE_ENGINE_FIELDS';

export const CREATE_DRIVER_SELF_RATING = 'CREATE_DRIVER_SELF_RATING';
export const CREATE_DRIVER_SELF_RATING_LOADING = 'CREATE_DRIVER_SELF_RATING_LOADING';
export const CREATE_DRIVER_SELF_RATING_ERROR = 'CREATE_DRIVER_SELF_RATING_ERROR';
export const CREATE_DRIVER_SELF_RATING_SUCCESS = 'CREATE_DRIVER_SELF_RATING_SUCCESS';

export const FETCH_DRIVER_SELF_RATING_OPTIONS = 'FETCH_DRIVER_SELF_RATING_OPTIONS';
export const FETCH_DRIVER_SELF_RATING_OPTIONS_LOADING = 'FETCH_DRIVER_SELF_RATING_OPTIONS_LOADING';
export const FETCH_DRIVER_SELF_RATING_OPTIONS_ERROR = 'FETCH_DRIVER_SELF_RATING_OPTIONS_ERROR';
export const FETCH_DRIVER_SELF_RATING_OPTIONS_SUCCESS = 'FETCH_DRIVER_SELF_RATING_OPTIONS_SUCCESS';

/* *************************************************************************************************
Series
************************************************************************************************* */
export const FETCH_SERIES = 'FETCH_SERIES';
export const FETCH_SERIES_LOADING = 'FETCH_SERIES_LOADING';
export const FETCH_SERIES_ERROR = 'FETCH_SERIES_ERROR';
export const FETCH_SERIES_SUCCESS = 'FETCH_SERIES_SUCCESS';

/* *************************************************************************************************
Tracks
************************************************************************************************* */
export const FETCH_TRACKS = 'FETCH_TRACKS';
export const FETCH_TRACKS_LOADING = 'FETCH_TRACKS_LOADING';
export const FETCH_TRACKS_ERROR = 'FETCH_TRACKS_ERROR';
export const FETCH_TRACKS_SUCCESS = 'FETCH_TRACKS_SUCCESS';

/* *************************************************************************************************
UI
************************************************************************************************* */
export const ENABLE_SUBMIT = 'ENABLE_SUBMIT';
export const DISABLE_SUBMIT = 'DISABLE_SUBMIT';
export const UPDATE_RULES = 'UPDATE_RULES';
